const Permissions = ['read', 'write', 'publish']

export default Permissions
